export default __webpack_public_path__ + "img/check.7e670b4d.svg";